import { defineMessages } from 'react-intl';

export default defineMessages({
	title: {
		id: 'RobotsPage.transfer',
		defaultMessage: 'Transfer Robot',
		description: 'Transfer Robot',
	},
	cancel: {
		id: 'RobotsPage.cancel',
		defaultMessage: 'Cancel',
		description: 'Cancel',
	},
	save: {
		id: 'RobotsPage.save',
		defaultMessage: 'Transfer',
		description: 'Transfer',
	},
	from: {
		id: 'RobotsPage.from',
		defaultMessage: 'From organization',
		description: 'From organization',
	},
	toOrganization: {
		id: 'RobotsPage.toOrganization',
		defaultMessage: 'To Organization',
		description: 'To Organization',
	},
	transferWarning: {
		id: 'RobotsPage.transferWarning',
		defaultMessage:
			'The transferred robot(s) will be unassigned from their Robot Groups and users in this organization will lose access to them.',
		description:
			'The transferred robot(s) will be unassigned from their Robot Groups and users in this organization will lose access to them.',
	},
});
